// Formular „Neuer Zähler“ / „Zähler bearbeiten“ – reine Funktionen. Felder und Payload wie bisher
// (zaehlerPayload aus dem Immobilienbereich), Prüftexte exakt wie im Zählerbereich (Handoff §5.4).

import type { ZaehlerEntwurf } from '../immobilien/zaehlerFormular';
import { istStandardTyp, ZAEHLER_TYPEN } from './typen';
import type { ZaehlerObjekt } from './liste';

export type { ZaehlerEntwurf };

/** Auswahlwert für „Sonstig...“ (freier Typ) – wie im Immobilienbereich. */
export const EIGENER_TYP = '_eigen';

export const TYP_AUSWAHL: readonly { key: string; label: string }[] = [
  ...ZAEHLER_TYPEN.map(t => ({ key: t.key, label: t.label })),
  { key: EIGENER_TYP, label: 'Sonstig...' },
];

interface ZaehlerQuelle {
  zaehler_nummer: string; typ: string; einheit: string | null; standort: string | null; haus_id: string | null;
  einheit_bezeichnung: string | null; mieter_id: string | null; notizen: string | null;
}

/** Leerer Entwurf (Strom, kWh) oder die Werte eines bestehenden Zählers. */
export function entwurfAus(z: ZaehlerQuelle | null): ZaehlerEntwurf {
  if (!z) {
    return { zaehler_nummer: '', typ: 'strom', eigenerTyp: '', einheit: 'kWh', standort: '', haus_id: '', einheit_bezeichnung: '', mieter_id: '', notizen: '' };
  }
  const bekannt = istStandardTyp(z.typ);
  return {
    zaehler_nummer: z.zaehler_nummer, typ: bekannt ? z.typ : EIGENER_TYP, eigenerTyp: bekannt ? '' : z.typ, einheit: z.einheit ?? '',
    standort: z.standort ?? '', haus_id: z.haus_id ?? '', einheit_bezeichnung: z.einheit_bezeichnung ?? '', mieter_id: z.mieter_id ?? '', notizen: z.notizen ?? '',
  };
}

/** Typwechsel setzt die Standard-Messeinheit (freier Typ lässt sie stehen). */
export function mitTyp(e: ZaehlerEntwurf, typ: string): ZaehlerEntwurf {
  const t = ZAEHLER_TYPEN.find(x => x.key === typ);
  return { ...e, typ, einheit: t ? t.einheit : e.einheit };
}

/** Prüfung wie bisher – Texte exakt aus dem Zählerbereich. */
export function formularFehler(e: ZaehlerEntwurf, objektId: string | null): string | null {
  if (!e.zaehler_nummer.trim() || !objektId) return 'Bitte Zählernummer und Objekt angeben.';
  if (!(e.typ === EIGENER_TYP ? e.eigenerTyp.trim() : e.typ)) return 'Bitte Zählertyp angeben.';
  return null;
}

/**
 * Objektnummer als Präfix der Zählernummer vorschlagen – nur wenn das Feld leer ist oder noch den
 * zuletzt vorgeschlagenen Präfix enthält (echte Eingaben bleiben stehen).
 */
export function nummerMitPraefix(nummer: string, alterVorschlag: string, objektnummer: string | null | undefined): { nummer: string; vorschlag: string } {
  const vorschlag = objektnummer ? `${objektnummer}-` : '';
  return { nummer: !nummer.trim() || nummer === alterVorschlag ? vorschlag : nummer, vorschlag };
}

/** „0001 · Alte Straße 17 — Alte Straße 17“ wie bisher im Objektfeld */
export function objektLabel(o: Pick<ZaehlerObjekt, 'objektnummer' | 'bezeichnung' | 'strasse' | 'hausnummer'>): string {
  const adresse = [o.strasse, o.hausnummer].filter(Boolean).join(' ');
  return `${o.objektnummer ? `${o.objektnummer} · ` : ''}${o.bezeichnung ?? ''}${adresse ? ` — ${adresse}` : ''}`;
}
